import LogoMobileES from '../../assets/images/logos/LogoCircle1_ES.svg'
import LogoMobilePT from '../../assets/images/logos/LogoCircle1_PT.svg'
import LogoES from '../../assets/images/logos/LogoPill1_ES.svg'
import LogoPT from '../../assets/images/logos/LogoPill1_PT.svg'
import Mapa from '../../assets/images/map.png'
import './metodologia.scss'

import { Link } from '@mui/material'
import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import i18n from '../../i18n/i18n'
import { CustomToolTip } from '../../shared/components/CustomToolTip/CustomToolTip'
import { Footer } from '../../shared/components/Footer/Footer'
import HowIsWasDoneModal from '../../shared/components/HowIsWasDoneModal/HowIsWasDoneModal'
import { ProyectosTotal } from '../../shared/constants/proyectos'

export const Metodologia = () => {
  const { t }: any = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  )

  const [isHowIsWasDoneOpen, setIsHowIsWasDoneOpen] = useState(true)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    const handleChange = (e: any) => setIsMobile(e.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  const getActiveClass = (lang: string) => {
    return location.search.includes(`lang=${lang}`) ? 'language-active' : ''
  }

  // Function to determine which logo to display based on the language and device type
  const findLogo = () => {
    if (isMobile) {
      return i18n.language.includes('es') || i18n.language.includes('en')
        ? LogoMobileES
        : LogoMobilePT
    } else {
      return i18n.language.includes('es') || i18n.language.includes('en')
        ? LogoES
        : LogoPT
    }
  }

  return (
    <div className="home">
      <header>
        <div>
          <ul className="languages">
            <li>
              <Link
                href="?lang=es"
                className={`language-option ${getActiveClass('es')}`}
              >
                ES
              </Link>
            </li>
            <li>
              <Link
                href="?lang=pt"
                className={`language-option ${getActiveClass('pt')}`}
              >
                PT
              </Link>
            </li>
            <li>
              <Link
                href="?lang=en"
                className={`language-option ${getActiveClass('en')}`}
              >
                EN
              </Link>
            </li>
          </ul>
          {isMobile && (
            <div className="title">
              <h1>
                <span>{t('title')}</span>
              </h1>
            </div>
          )}
        </div>
        <img
          style={!isMobile ? { width: 270, height: 90 } : {}}
          src={findLogo()}
          alt="Carbono Opaco"
        />
      </header>

      <main>
        <div className="main_container">
          <div className="map">
            <div>
              {!isMobile ? (
                <div className="title">
                  <h1>
                    <span>{t('title')}</span>
                  </h1>
                </div>
              ) : null}

              {/* <p className="description">{t('description')}</p> */}
              <p className="description">
                <Trans
                  i18nKey="description"
                  components={{
                    customToolTip: (
                      <CustomToolTip
                        highlight
                        title={<Trans i18nKey="REEDTooltip" />}
                      />
                    ),
                  }}
                />
              </p>
              <p className="last-update">
                <small>{t('lastUpdate')}</small>
              </p>
            </div>
            <div className="map-image-container">
              <img src={Mapa} alt="Mapa" className="map-image" />
              <p className="counter brazil-projects">
                {ProyectosTotal.brasil}
                <span>{t('countries.brasil')}</span>
              </p>
              <p className="counter colombia-projects">
                {ProyectosTotal.colombia}
                <span>{t('countries.colombia')}</span>
              </p>
              <p className="counter peru-projects">
                {ProyectosTotal.peru}
                <span>{t('countries.peru')}</span>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      {isHowIsWasDoneOpen && (
        <HowIsWasDoneModal
          open={isHowIsWasDoneOpen}
          onClose={() => {
            console.log('close')
            navigate('/')
          }}
        />
      )}
    </div>
  )
}
